import { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { authSelectors } from 'redux/auth';
import { buildBrand, findServedBrand } from 'brands';

const BrandContext = createContext(null);

export const BrandProvider = BrandContext.Provider;

const useBrand = () => {

  const providedBrand = useContext(BrandContext);

  // The last workspace stays in the store after logout
  const workspaceType = useSelector(state => (authSelectors.getUserIsLoggedIn(state) ? authSelectors.getWorkspace(state)?.type : undefined));

  return providedBrand ?? findServedBrand(workspaceType) ?? buildBrand;
};

export default useBrand;
